module.exports = __webpack_public_path__ + "static/media/intent-visual.b6f17ee9.png";